import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { LoadingService } from '@mds/ngx-core';
import { EMPTY, finalize, first } from 'rxjs';
import { DeploymentResponse, DeploymentsClient } from '../../../shared';

export const deploymentResolver: ResolveFn<DeploymentResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(DeploymentsClient);
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  const id = Number(route.paramMap.get('deploymentId'));

  if (Number.isNaN(id)) {
    void router.navigate(['deployments']);
    return EMPTY;
  }

  loadingService.start();

  return client.getDeploymentById(id).pipe(
    first(),
    finalize(() => loadingService.end()),
  );
};
